import { Component, Input } from '@angular/core';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';

@Component({
  selector: 'boi-form-declaration-radio-button',
  templateUrl: './form-declaration-radio-button.component.html',
  styleUrls: ['./form-declaration-radio-button.component.scss']
})
export class FormDeclarationRadioButtonComponent extends BaseFormControlComponent {
  @Input() public optionList: any;

  constructor() {
    super();
  }
}
